/**
 * Mirrors the backend's APPOINTMENT_CANCELLATION_CUTOFF_HOURS (slot/models.py).
 *
 * The API is the authority: it refuses a cancellation inside this window with a
 * 400 whose text the console shows verbatim. This copy exists only to warn the
 * user before they try, and must never gate the attempt. Delete it once the
 * backend exposes `can_cancel` on the appointment payload.
 */
export const APPOINTMENT_CANCELLATION_CUTOFF_HOURS = 4;
